import React, { useState, useEffect, useMemo } from "react";
import './Carousal.css';

const TextCarousal = (props) => {
    const parser = new DOMParser();
    const dom = parser.parseFromString(props.description, 'text/html');
    const title = parser.parseFromString(props.title, 'text/html');

    return (
        <>
            <div className="videoCarousal-main-div">
                <img id="video-slide-app-logo" src={props.logoSrc} className="video-slide-app-logo" alt="app logo" />
            </div>
            <div id="slide-header" className='slide-header'>
                <div dangerouslySetInnerHTML={{ __html: title.body.innerHTML }} />
                <div id="carausal-list-item-content" className="carausal-list-item-content text-carousal-content" dangerouslySetInnerHTML={{ __html: dom.body.innerHTML }} />
            </div>
        </>
    );
};

export default TextCarousal;